import { useMemo, useState } from 'react';
import FilmCard from '@/components/feature/FilmCard';
import { films } from '@/mocks/films';

const tabs = [
  { key: 'hot', label: '热门推荐' },
  { key: 'new', label: '最新上线' },
] as const;

export default function EditorPicks() {
  const [tab, setTab] = useState<'hot' | 'new'>('hot');

  const list = useMemo(() => {
    const sorted = [...films].sort((a, b) =>
      tab === 'hot' ? b.heat - a.heat : b.year - a.year,
    );
    return sorted.slice(0, 8);
  }, [tab]);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
        <div className="flex flex-col gap-2">
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-accent-500" />
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500 pl-4">为你整理值得一看的影视作品</p>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 w-fit">
          {tabs.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setTab(item.key)}
              className={[
                'px-4 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer',
                tab === item.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900',
              ].join(' ')}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {list.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>
    </section>
  );
}